module.exports = __webpack_public_path__ + "img/arrow-circlepath-right.4261e6f.svg";